import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0;
  float: left;

  @media (max-width: 1024px) {
    width: 100%;
    height: auto;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  float: left;
  align-items: center;
  padding: 1rem;

  @media (max-width: 1024px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    padding: 0px;
  }
`;

export const Right = styled.div`
  display: flex;
  float: left;
  flex-direction: row;
  padding: 10px;
    
  
  main {
    display: flex;
    flex-direction: row;
  }

  @media (max-width: 1024px) {
    width: 100%;
    align-items: flex-start;
    padding: 15px 10px 10px 10px;
    background: ${({ theme }) => theme.colors.BG2};
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};

    &.search-enable {
      display: flex;
    }

    &.search-disable {
      display: none;
    }

    main {
      width: auto;
      padding: 0px;

      button {
        padding: 0px 15px;
        height: 50px;
        margin: 0px 0 0 2px;
      }

      span,
      ins,
      small {
        display: none;
      }
    }
  }
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.TEXT1};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  align-items: center;

  i {
    margin: 0 10px 0 0;
  }

  button {
    background: none;
    margin-right: 10px;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.5;
    }
  }

  div {
    display: flex;
    flex-direction: column;
  }

  h1 {
    font-size: 1.4rem;
    font-weight: 700;
  }

  h2 {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.TEXT4};
    font-weight: 400;
  }

  @media (max-width: 1024px) {
    margin-bottom: 5px;
    font-size: 18px;
    display: none;
  }
`;

export const PlusBtn = styled.button.attrs({
  type: 'button',
})`
  display: flex;
  flex-direction: row;
  float: left;
  align-items: center;
  padding: 0rem 1rem;
  height: 60px;
  border-radius: 0.4rem;
  background: ${({ theme }) => theme.colors.LIGHT1};
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  transition: all 0.5s ease;
  margin: 0px 0px 0px 40px;

  &:hover {
    background: #f5f5f5;
  }

  span {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 16px;
    font-weight: 700;
    margin-left: 0.5rem;
  }

  @media (max-width: 1024px) {
    margin: 0px;
    width: 100%;
  }
`;

export const Search = styled.div`
  display: flex;
  flex-direction: row;
  float: left;
  align-items: center;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  height: 50px;
  width: 100%;
  max-width: 40rem;
  margin: 0px;
  border-radius: 10px;
  padding: 0px 10px 0 0;


  input {
    background: none;
    width: 100%;
    float: left;
    height: 50px;
    padding: 0 15px;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 14px;
    border: none;
    font-weight: 700;
  }

  button {
    background: none;
    cursor: pointer;
    transition: all 0.5s ease;

    &:hover {
      opacity: 0.7;
    }
  }

  button.close {
    opacity: 0.6;
  }

  button.search {
    margin-left: 10px;
  }

  @media (max-width: 1024px) {
    margin: 0px 0px 0px 0;
    padding: 0px 10px 0 0;
    display: flex;
    flex: 1;
    max-width: 100%;

    input {
      height: 60px;
      font-size: 12px;
      padding: 0 0px 0 10px;
      border-radius: 0.6rem;
    }
  }
`;

export const FilterBtn = styled.button`
  height: 50px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 8px;
  padding: 0 2rem;
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  transition: all 0.5s ease;
  margin: 0 0 0 10px;

  &:hover {
    color: ${({ theme }) => theme.colors.LIGHT2};
    text-decoration: underline;
  }

  span {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 12px;
    font-weight: 700;
    padding: 0 0 0 10px;
  }

  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 1024px) {
    height: 40px;
    font-size: 0.8rem;
  }
`;

export const IaBtn = styled.button`
  height: 50px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 8px;
  padding: 0 2rem;
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  transition: all 0.5s ease;
  display: flex;
  flex-direction: row;
  margin: 0 0 0 10px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.LIGHT2};
    text-decoration: underline;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  small {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 8px;
  }
  span {
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 12px;
    font-weight: 700;
  }

  ins {
    background: rgb(19, 226, 123);
    font-weight: 700;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-size: 10px;
    position: relative;
    margin: -35px -35px 0 5px;
    padding: 5px;
    border-radius: 8px;
    text-transform: uppercase;
    text-decoration: none;
  }

  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const RefreshBtn = styled.button`
  height: 50px;
  padding: 0 10px;
  background-color: ${({ theme }) => theme.colors.LIGHT1};
  border-radius: 100%;
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  cursor: pointer;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  transition: all 0.5s ease;
  margin: 0 0 0 10px;
  float: left;

  &:hover {
    background: #000;
    text-decoration: underline;
  }

  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media (max-width: 1024px) {
    height: 40px;
    font-size: 0.8rem;
  }
`;
